// oauth-redirect.component.ts
import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OurAuthService } from 'app/core/auth/auth.service';

@Component({
  selector: 'app-oauth-redirect',
  template: '<p>Processing login... Please wait.</p>',
})
export class OAuthRedirectComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private authService: OurAuthService,
    private router: Router,
    @Inject(DOCUMENT) private document: Document
  ) {}

   

  ngOnInit() {
    
    this.route.queryParams.subscribe((params) => {
      const code = params['code']; // The authorization code

      // If the code is present, proceed to exchange it for tokens
      if (code) {
        this.authService.exchangeAuthCodeForToken(code).subscribe(
          (response) => {
            // Assuming the response contains the tokens and you have a method to handle the login
            this.authService.handleLogin(response);
            
            // Redirect to the desired route after login
            this.router.navigateByUrl('/overview');
          },
          (error) => {
            console.error('There was an error exchanging the authorization code.', error);
            // Redirect to login page or show an error message
            this.router.navigateByUrl('/login');
          }
        );
      } else {
        // If the code isn't present in the callback, handle the error
        console.error('Authorization code not found. Login failed.');
        // Redirect to login page or show an error message
        this.router.navigateByUrl('/login');
      }
    });
  }
}
